import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_keyless-vending-1/artifacts/9rpednbz_keyless-vending-logo.png';

export const Hero = () => {
  const handleScroll = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden noise"
      style={{
        background: 'radial-gradient(1200px circle at 50% 0%, rgba(214,178,76,0.08), transparent 55%), radial-gradient(900px circle at 80% 20%, rgba(255,255,255,0.04), transparent 40%), #0B0B0C',
      }}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col items-center text-center pt-24 pb-16">
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <img
            src={LOGO_URL}
            alt="Keyless Vending"
            className="h-44 sm:h-60 lg:h-72 w-auto object-contain mb-8 sm:mb-12"
          />
        </motion.div>

        {/* Headline */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="text-4xl sm:text-5xl lg:text-6xl font-display tracking-tight text-white leading-tight mb-6"
        >
          Premium Vending,{' '}
          <span className="text-kv-gold">Zero Hassle.</span>
        </motion.h1>

        {/* Subtext */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="text-base sm:text-lg text-white/60 max-w-xl mx-auto mb-10 leading-relaxed font-sans"
        >
          Fully managed vending solutions for San Antonio businesses &mdash; stocked, serviced, and handled entirely by us.
        </motion.p>

        {/* CTAs */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-col sm:flex-row gap-4 mb-16"
        >
          <a
            href="#contact"
            data-testid="hero-get-free-machine-button"
            onClick={(e) => handleScroll(e, '#contact')}
            className="inline-flex items-center justify-center gap-2 rounded-full bg-kv-gold text-kv-black hover:bg-kv-gold-2 active:scale-[0.98] px-7 py-3.5 text-sm font-semibold transition-colors"
          >
            Get a Free Machine <ArrowRight className="h-4 w-4" />
          </a>
          <a
            href="#machines"
            data-testid="hero-see-machines-button"
            onClick={(e) => handleScroll(e, '#machines')}
            className="inline-flex items-center justify-center rounded-full border border-white/20 bg-transparent text-white hover:bg-white/5 px-7 py-3.5 text-sm font-medium transition-colors"
          >
            See Our Machines
          </a>
        </motion.div>

        {/* Location text */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.7, delay: 0.65 }}
          className="text-xs sm:text-sm text-white/40 tracking-wide font-sans"
        >
          Proudly Serving San Antonio, TX
        </motion.p>
      </div>
    </section>
  );
};
